export default "__VITE_ASSET__kCUT$NSn__"